module.exports = __webpack_public_path__ + "static/img/5913_phase_function_Paper_Points.0d3b16f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/5913_phase_function_Paper_Points.png
// module id = ev1m
// module chunks = 0